import { useTranslation } from 'react-i18next';

import { Card } from '@components/molecules/Card/Card';
import {
    MobileModal,
    MobileModalProps,
} from '@components/organisms/MobileModal/MobileModal';

import { useUserLogin } from '@utils/hooks/useUserLogin';

import { LoginForm } from '@domains/auth/organisms/LoginForm/LoginForm';

interface MobileLoginModalProps
    extends Pick<MobileModalProps, 'onClose' | 'open'> {}

export const MobileLoginModal = ({ onClose, open }: MobileLoginModalProps) => {
    const { t } = useTranslation();

    const { login, sessionProcessing } = useUserLogin({
        modalName: 'MobileLoginModal',
    });

    return (
        <MobileModal footer onClose={onClose} open={open} topPadding={54}>
            <MobileModal.Container>
                <Card testId="mWY1kDl">
                    <Card.TitleTertiary fontWeight="normal">
                        {t('ALREADY_HAVE_AN_ACCOUNT')}
                    </Card.TitleTertiary>
                    <Card.Description>
                        {t('NEW_LOGIN_DESCRIPTION')}
                    </Card.Description>
                    <LoginForm
                        handleLoginSubmit={login}
                        loading={sessionProcessing}
                        showMfaStep={false}
                    />
                </Card>
            </MobileModal.Container>
        </MobileModal>
    );
};
